// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact_Contact__3xOgl","Contact__title":"Contact_Contact__title__16OpL","Contact__p":"Contact_Contact__p__ODtI2"};